<template>
  <div>
    <b-dropdown
      v-model="content"
      right
      no-caret
      variant="link"
      class="sort-dropdown float-right"
    >
      <template slot="button-content">
        <i class="icon"><icon-chevron-down /></i> {{ displayedWord }}
      </template>
      <b-dropdown-item
        v-for="sortVal in sortValues"
        :key="sortVal"
        :href="href"
        :class="{ active: sortVal == content }"
        @click="content = sortVal"
      >
        {{ $t(`${translation}.${((sortVal === 'partnerTags') ? 'partnerTags.' + partnerTagName : sortVal)}`) }}
      </b-dropdown-item>
    </b-dropdown>
  </div>
</template>
<script>
import { BDropdown, BDropdownItem } from 'bootstrap-vue';
import 'scss/bootstrap/vue/components/dropdown.scss';

import IconChevronDown from 'ICON:IconChevronDown';
import GtmTools from 'mixins/GtmTools';
// import { gtmFilterMapping } from 'config/trackingParams';

export default {
  name: 'SortDropdown',
  components: { BDropdown, IconChevronDown, BDropdownItem },
  mixins: [GtmTools],
  model: {
    prop: 'fieldValue',
  },
  props: {
    sortValues: {
      type: Array,
      required: true,
    },
    fieldValue: {
      required: true,
      type: [String, Number],
    },
    displayedWord: {
      type: String,
      required: true,
    },
    translation: {
      type: String,
      required: true,
    },
    href: {
      type: String,
      required: false,
      default: '',
    },
  },
  computed: {
    content: {
      // get fieldValue
      get() {
        return this.fieldValue;
      },
      // emit fieldValue in to the upper scope
      set(newContent) {
        // const gtmString = gtmFilterMapping.sort[newContent];
        this.dataLayerPush({ event: 'asnsortierung', asnsortierung: newContent });
        this.$emit('input', newContent);
      },
    },
    partnerTagName() {
      return this.$store.getters.getPartnerConfigValue('partnerTagName');
    },
  },
};
</script>
<style lang="scss" scoped>
  .sort-dropdown {
    display: block;
    line-height: 1em;
  }

  /deep/ .sort-dropdown > .dropdown-menu {
    line-height: 1.5;
  }
</style>
